import COS from 'cos-js-sdk-v5';
import './App.css';
import { useParams } from 'react-router-dom';
const GetFile = () => {
    const { fileName } = useParams();
    const cos = new COS({
        // getAuthorization 必选参数
        getAuthorization: function (options, callback) {
          // 初始化时不会调用，只有调用 cos 方法（例如 cos.putObject）时才会进入
          // 异步获取临时密钥
          // 服务端 JS 和 PHP 例子：https://github.com/tencentyun/cos-js-sdk-v5/blob/master/server/
          // 服务端其他语言参考 COS STS SDK ：https://github.com/tencentyun/qcloud-cos-sts-sdk
          // STS 详细文档指引看：https://cloud.tencent.com/document/product/436/14048
          const url = 'https://api.lynne.com.cn/wiki/uploadFile'; // url 替换成您自己的后端服务
          const xhr = new XMLHttpRequest();
          xhr.open('GET', url, true);
          xhr.onload = function (e) {
            let data = null;
            let credentials = null;
            try {
                data = JSON.parse(
                    (e.target as XMLHttpRequest).responseText
                );
              credentials = data.credentials;
            } catch (e) {
            }
            if (!data || !credentials) {
              return console.error('credentials invalid:\n' + JSON.stringify(data, null, 2))
            }
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
            });
          };
          xhr.send();
        }
      });
      
      cos.getObjectUrl({
        Bucket: 'lynne-1252518086', // 必须
        Region: 'ap-shanghai',     // 存储桶所在地域，必须字段
        Key: fileName || '',              // 必须
      }, function (err, data) {
        if (err) {
          // 处理请求出错
          console.log(err);
        } else {
          // 处理请求成功
          window.location.href = data.Url;
        }
      });
    return <div>文件下载中喵...</div>
};

export default GetFile;
